module.exports = __webpack_public_path__ + "img/4linux.4f7b45a4.png";